import React from 'react'
import { AdminMessage } from '../../shared/types/adminMessage.type'
import { isEmpty } from 'lodash'
import { Stack } from '@mui/material'
import MessageBanner from './MessageBanner'

type UserMessagesBannersProps = {
    messages: AdminMessage[],
    loading: boolean
}

function UserMessagesBanners({ messages, loading }: UserMessagesBannersProps) {


    //if loading or no messages dont show anything
    if (loading || isEmpty(messages)) return null

    return (
        <Stack direction={'column'}>
            {
                messages.map(msg =>
                    <MessageBanner message={msg} key={msg.id} />
                )
            }

        </Stack>
    )
}

export default UserMessagesBanners